var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.slide.settings.timer)?_c('TimerControl',{on:{"subcommand":_vm.subcommand}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }